import { render, staticRenderFns } from "./UserSwitcher.vue?vue&type=template&id=537a5d4a&"
import script from "./UserSwitcher.vue?vue&type=script&lang=js&"
export * from "./UserSwitcher.vue?vue&type=script&lang=js&"
import style0 from "./UserSwitcher.vue?vue&type=style&index=0&id=537a5d4a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports